/*
  Winkelmandje-herstel (Claude, okt 2026)
  Shopify geeft een regel in het winkelmandje soms een nieuwe sleutel, bv. wanneer een korting zoals
  "2e aan halve prijs" op een ander stuk overspringt. Klikt de klant daarna op aanpassen of verwijderen met de
  oude sleutel, dan antwoordt Shopify "geen geldige ID of regelnummer". Dit script vangt dat op: het haalt het
  actuele winkelmandje op, zoekt dezelfde variant terug en voert de wijziging opnieuw uit met de nieuwe sleutel.
*/
(function () {
  if (!window.fetch || window.__btolCartHerstel) return;
  window.__btolCartHerstel = true;

  var origineel = window.fetch.bind(window);

  function isChange(url) {
    return typeof url === 'string' && /\/cart\/change(\.js)?(\?|$)/.test(url);
  }

  function leesBody(body) {
    if (typeof body === 'string') {
      try { return { soort: 'json', data: JSON.parse(body) }; } catch (e) { /* geen JSON */ }
      return { soort: 'params', data: new URLSearchParams(body) };
    }
    if (body instanceof URLSearchParams) return { soort: 'params', data: new URLSearchParams(body.toString()) };
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { soort: 'form', data: body };
    return null;
  }

  function haalId(b) {
    if (!b) return null;
    if (b.soort === 'json') return b.data.id;
    return b.data.get('id');
  }

  function zetId(b, id) {
    if (b.soort === 'json') { b.data.id = id; return JSON.stringify(b.data); }
    if (b.soort === 'params') { b.data.set('id', id); return b.data.toString(); }
    var f = new FormData();
    b.data.forEach(function (v, k) { f.append(k, k === 'id' ? id : v); });
    return f;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isChange(url) || !init || !init.body) return origineel(input, init);

    var b = leesBody(init.body);
    var id = haalId(b);
    if (!id || String(id).indexOf(':') === -1) return origineel(input, init);

    return origineel(input, init).then(function (antwoord) {
      if (antwoord.status !== 400 && antwoord.status !== 422) return antwoord;
      var variant = String(id).split(':')[0];
      return origineel((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var regel = (cart.items || []).filter(function (it) { return String(it.variant_id) === variant; })[0];
          if (!regel || regel.key === id) return antwoord;
          var nieuw = Object.assign({}, init, { body: zetId(b, regel.key) });
          return origineel(input, nieuw);
        })
        .catch(function () { return antwoord; });
    });
  };
})();

/*
  Taal en landversie op de order (Claude, okt 2026)
  Zet de taal van de website (nl/fr/de) en de landversie (markt/land) als winkelwagenattributen 'Taal' en
  'Landversie'. Shopify neemt die mee naar de order, waar ze onder 'Aanvullende gegevens' staan.
  Wordt verstuurd zodra er een winkelwagen is (bij het openen van een pagina, na elk toevoegen en bij 'Afrekenen').
*/
(function () {
  if (window.__btolTaalLand) return;
  window.__btolTaalLand = true;
  var S = window.Shopify || {};
  var taalCode = String(S.locale || document.documentElement.lang || 'nl').toLowerCase();
  var landCode = String(S.country || '').toUpperCase();
  var talen = { nl: 'Nederlands', fr: 'Frans', de: 'Duits', en: 'Engels' };
  var landen = { BE: 'België', NL: 'Nederland', DE: 'Duitsland', FR: 'Frankrijk', LU: 'Luxemburg', ES: 'Spanje' };
  var taal = (talen[taalCode.split('-')[0]] || taalCode) + ' (' + taalCode + ')';
  var land = landCode ? (landen[landCode] || landCode) + ' (' + landCode + ')' : '';
  var attrs = { 'Taal': taal };
  if (land) attrs['Landversie'] = land;
  var root = (S.routes && S.routes.root) || '/';
  var url = root + 'cart/update.js';
  var body = JSON.stringify({ attributes: attrs });

  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? m[1] : '';
  }
  function vlag() { return cartToken() + '|' + taal + '|' + land; }
  function alGestuurd() { try { return sessionStorage.getItem('btolTaalLand') === vlag(); } catch (e) { return false; } }
  function onthoud() { try { sessionStorage.setItem('btolTaalLand', vlag()); } catch (e) {} }

  function stuur(beacon) {
    if (beacon && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      onthoud();
      return;
    }
    fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { if (r.ok) onthoud(); })
      .catch(function () {});
  }

  /* bij het openen van een pagina: alleen als er al een winkelwagen is en hij nog niet bijgewerkt werd */
  if (cartToken() && !alGestuurd()) stuur(false);

  /* na toevoegen aan het winkelmandje */
  var f = window.fetch;
  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = f.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(u)) {
      p.then(function (r) { if (r && r.ok && !alGestuurd()) setTimeout(function () { stuur(false); }, 300); }).catch(function () {});
    }
    return p;
  };

  /* bij Afrekenen en snelle betaalknoppen: altijd nog eens meesturen */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (t) stuur(true);
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && /\/cart(\?|$)/.test(e.target.action)) stuur(true);
  }, true);
})();
